import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import {
  StoreType,
  StoreSubType,
} from "../../types/modules/admin/storeType.type";

export const useStoreTypesByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["store-types-by-admin"],
    queryFn: () => fetcher<StoreType[]>(`type/admin/all`, token),
  });
};

export const useStoreSubTypesByAdmin = (typeId: number) => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["store-sub-types-by-admin", typeId],
    queryFn: () =>
      fetcher<StoreSubType[]>(`subtype/admin/byType/${typeId}`, token),
  });
};
